// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_dist_xlsx_mini_min_js":"ed4dd6f39a9d63da","node_modules_xlsx_xlsx_mjs":"3527554af8064a0e","node_modules_html2canvas_dist_html2canvas_js":"2ec96243c4d92cc6","node_modules_canvg_lib_index_es_js":"05c8def189c5b728"}[chunkId] + ".js";
};